// @flow
import DisconnectIcon from 'esm-web-pro/components/layout/sidePanel/icons/DisconnectIcon';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import { injectIntl, IntlShape } from 'react-intl';
import { withRouter } from 'react-router';
import * as React from 'react';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';

type Props = {
    cable: Object,
    point: Object,
    intl: IntlShape,
    history: Object,
    match: Object,
    mapIsDraft: boolean,
    onDisconnectCable: Function,
    message: string,
    onHighlight: Function,
    clicked: ?string,
    padLevel: 2 | 3,
};

const Point12Cable = (props: Props) => {
    const {
        cable, intl: { formatMessage }, history: { push }, match: { url }, mapIsDraft, onDisconnectCable,
        point, onHighlight, clicked, message, padLevel,
    } = props;

    const cableActions = [
        {
            key: `cable-${cable.id}-more`,
            icon: <MeatballsIcon />,
            size: '20px',
            width: '3px',
            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                const path = url.split('/layer');
                push(`${path[0]}/layer/cable/${cable.identity}`);
            },
            tooltip: formatMessage(actionMessages.more),
        },
    ];

    if (mapIsDraft && !cable.patch) {
        cableActions.unshift({
            key: `cable-${cable.id}-disconnect`,
            icon: <DisconnectIcon />,
            size: '20px',
            width: '3px',
            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                onDisconnectCable(cable, point);
            },
            tooltip: formatMessage(actionMessages.disconnect),
        });
    }
    return (
        <>
            <ContentRow
                actions={<RowActions width="auto" actions={cableActions} />}
                onClick={() => !cable.patch && onHighlight(cable)}
                rowId={`cable-${cable.id}`}
                clickedRowIdentity={clicked}
                padLevel={padLevel}
            >
                <ValueText>
                    {message}
                </ValueText>
            </ContentRow>
        </>
    );
};

Point12Cable.defaultProps = {
    padLevel: 1,
};

export default withRouter(injectIntl(Point12Cable));
